import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "@/lib/utils";

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap font-sans font-bold transition-[transform,background-color,border-color,opacity] duration-[180ms] ease-fx active:scale-[0.98] disabled:pointer-events-none disabled:opacity-40 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-[18px] shrink-0 [&_svg]:shrink-0 outline-none focus-visible:ring-[3px] focus-visible:ring-fx-focus-ring focus-visible:border-fx-red-line",
  {
    variants: {
      variant: {
        // CTA primário: creme com texto escuro
        default: "bg-fx-cream text-fx-on-cream hover:bg-fx-cream-hover",
        // secundário: contorno creme
        outline:
          "border border-fx-cream-border text-fx-cream hover:bg-fx-cream/5",
        // terciário: contorno neutro
        quiet: "border border-fx-line text-fx-body font-semibold hover:bg-fx-raised",
        ghost: "text-fx-secondary font-semibold hover:text-fx-title",
        link: "text-fx-cream font-semibold hover:text-fx-cream-hover",
        destructive: "text-fx-danger-ink font-semibold hover:bg-fx-red-surface",
      },
      size: {
        default: "h-12 rounded-md px-5 text-[15px]",
        sm: "h-10 rounded-md px-4 text-sm",
        lg: "h-[52px] rounded-lg px-6 text-[15px]",
        xl: "h-14 rounded-lg px-6 text-base",
        icon: "size-11 rounded-md",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

function Button({
  className,
  variant,
  size,
  asChild = false,
  ...props
}: React.ComponentProps<"button"> &
  VariantProps<typeof buttonVariants> & {
    asChild?: boolean;
  }) {
  const Comp = asChild ? Slot : "button";

  return (
    <Comp
      data-slot="button"
      className={cn(
        "cursor-pointer",
        buttonVariants({ variant, size, className })
      )}
      type="button"
      {...props}
    />
  );
}

export { Button, buttonVariants };
